import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";


export default class PingRequest implements IRequestBuilder {
    get method() {
      return "GET";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/ping";
    }
  
    get requestData() {
      return {
        sid: GameModel.sessionID,
      };
    }
  }